import {
  listOrder,
  invalidOrder,
  duplicateOrder,
  writeOffOrder,
  searchOrder,
  reprintInvoice,
  reprintOriginalInvoice,
} from '@/api/manageOrder';
import { orderInfo } from '@/api/order';
import Router from '../../router';

export default {
  namespaced: true,
  state: {
    orderList: [],
    searchingStatus: false,
    search: {
      date_type: 1,
      date_range: '',
      source: '',
      take_away_method: '',
      invoice_no: '',
      serial_no: '',
      order_user_name: '',
      order_user_tel: '',
      order_user_address: '',
      member_card_no: '',
    },
    searchList: [],
  },

  getters: {
    getAllManageOrderList: (state) => state.orderList,
    getSearchingStatus: (state) => state.searchingStatus,
    getSearchCondition: (state) => state.search,
    getSearchList: (state) => state.searchList,
  },

  mutations: {
    SET_ALL_ORDER_LIST(state, data) {
      state.orderList = data;
    },
    SET_SEARCH_CONDITION(state, data) {
      state.search = data;
    },
    SET_SEARCH_LIST(state, data) {
      state.searchList = data;
      state.searchingStatus = true;
    },
    CLEAR_SEARCH(state) {
      state.search = {
        date_type: 1,
        date_range: '',
        source: '',
        take_away_method: '',
        invoice_no: '',
        serial_no: '',
        order_user_name: '',
        order_user_tel: '',
        order_user_address: '',
        member_card_no: '',
      };
      state.searchingStatus = false;
      state.searchList = [];
    },
    RESET(state) {
      state.orderList = [];
    },
  },

  actions: {
    //取得訂單列表
    async doGetManageOrderList({ commit }) {
      const res = await listOrder();
      commit('SET_ALL_ORDER_LIST', res);
      return Promise.resolve();
    },
    //查看訂單
    async doGetOrderInfo(context, order_id) {
      const res = await orderInfo(order_id);
      return Promise.resolve(res);
    },
    //作廢訂單
    async doInvalidOrder({ dispatch, getters }, data) {
      const res = await invalidOrder(data);
      if (!data.with_duplicate) {
        if (getters.getSearchingStatus) {
          await dispatch('doSearchOrder', getters.getSearchCondition);
          return Promise.resolve();
        } else {
          await dispatch('doGetManageOrderList');
          return Promise.resolve();
        }
      } else {
        await dispatch('handleOrder/dorRestoreOrder', res.duplicate_order_id, { root: true });
        Router.push('/order');
        return Promise.resolve();
      }
    },
    //複製訂單
    async doDuplicateOrder({ dispatch }, order_id) {
      const res = await duplicateOrder(order_id);
      await dispatch('handleOrder/dorRestoreOrder', res.duplicate_order_id, { root: true });
      Router.push('/order');
      return Promise.resolve(res);
    },
    //沖銷訂單
    async doWriteOffOrder({ dispatch }, data) {
      await writeOffOrder(data);
      await dispatch('doGetManageOrderList');
      dispatch('system/doGetDutySection', '', { root: true });
      return Promise.resolve();
    },
    //進階搜尋訂單
    async doSearchOrder({ commit }, data) {
      const today = new Date().getLocalDateTime('date');
      const payload = JSON.parse(JSON.stringify(data));
      switch (payload.date_type) {
        case 1:
        case 2:
          payload.date_range = [today, today];
          break;
        case 3: {
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() === 0 ? 6 : start.getDay() - 1));
          payload.date_range = [start.getLocalDateTime('date'), today];
          break;
        }
        case 4:
          payload.date_range = [`${today.slice(0, 7)}-01`, today];
          break;
        case 5: {
          const month = new Date().getMonth() + 1;
          if (month < 4) payload.date_range = [`${today.slice(0, 4)}-01-01`, today];
          else if (month < 7) payload.date_range = [`${today.slice(0, 4)}-04-01`, today];
          else if (month < 10) payload.date_range = [`${today.slice(0, 4)}-07-01`, today];
          else payload.date_range = [`${today.slice(0, 4)}-10-01`, today];
          break;
        }
        case 6:
          payload.date_range = [
            data.date_range.text.split(' - ')[0].split('/').join('-'),
            data.date_range.text.split(' - ')[1].split('/').join('-'),
          ];
          break;
      }
      const res = await searchOrder(payload);
      commit('SET_SEARCH_CONDITION', data);
      commit('SET_SEARCH_LIST', res.list);
      return Promise.resolve();
    },
    //補印副本發票
    async doReprintInvoice(context, order_id) {
      await reprintInvoice(order_id);
      return Promise.resolve();
    },
    //重印正本發票
    async doReprintOriginalInvoice(context, order_id) {
      await reprintOriginalInvoice(order_id);
      return Promise.resolve();
    },
  },
};
